import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { bffAuthService } from '../../services/BffAuthService';

interface BffSecureProps {
  children: React.ReactNode;
}

// 认证探测期的品牌加载屏（03-1.4：不再整页白屏）
const CheckingView = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100vh',
      gap: 2,
    }}
  >
    <CircularProgress size={36} />
    <Typography variant="body2" color="text.secondary">
      Wise Memo
    </Typography>
  </Box>
);

export const BffSecure: React.FC<BffSecureProps> = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const isLoggedOutLoginPage = window.location.pathname === '/login' && bffAuthService.isExplicitlyLoggedOut();

  useEffect(() => {
    if (isLoggedOutLoginPage) {
      setChecking(false);
      setIsAuthenticated(false);
      return;
    }

    let mounted = true;

    const redirectToLoggedOutPage = () => {
      window.location.href = '/login?logged_out=true';
    };

    const checkAuth = async () => {
      try {
        const authenticated = await bffAuthService.initSession();
        if (mounted) {
          setIsAuthenticated(authenticated);
          setChecking(false);

          if (!authenticated) {
            if (bffAuthService.isExplicitlyLoggedOut()) {
              redirectToLoggedOutPage();
              return;
            }
            bffAuthService.login();
          }
        }
      } catch {
        if (mounted) {
          setIsAuthenticated(false);
          setChecking(false);
          if (bffAuthService.isExplicitlyLoggedOut()) {
            redirectToLoggedOutPage();
            return;
          }
          bffAuthService.login();
        }
      }
    };

    const unsubscribe = bffAuthService.subscribe(async (authenticated) => {
      if (mounted) {
        if (!authenticated) {
          if (bffAuthService.isExplicitlyLoggedOut()) {
            redirectToLoggedOutPage();
            return;
          }
          console.info('[BffSecure] Auth lost, attempting silent re-auth before redirect');
          const reauthed = await bffAuthService.trySilentReauth();
          if (mounted && !reauthed) {
            bffAuthService.login();
          }
        } else {
          setIsAuthenticated(true);
        }
      }
    });

    checkAuth();

    return () => {
      mounted = false;
      unsubscribe();
    };
  }, [isLoggedOutLoginPage]);

  if (isLoggedOutLoginPage) {
    return <>{children}</>;
  }

  if (checking) {
    return <CheckingView />;
  }

  if (!isAuthenticated) {
    // 未认证即将跳转登录：仍显示加载屏而不是白屏
    return <CheckingView />;
  }

  return <>{children}</>;
};
